@if (group && group.notFound.length) {
<div class="item-card">
  <div class="inner warning-list-not-found">
    @if (group.filterType == 'piece') { <div class="fs-6 fw-bold pb-2 capitalizeFirstLetter">
      Pièces inconnues ou non localisées
    </div>
  }
    @if (group.filterType != 'piece') { <div class="fs-6 fw-bold pb-2 capitalizeFirstLetter">
      {{ group.filterType }} non trouvées :
    </div>
  }
    @for (piece of group.notFound; track piece; let index = $index) {
      <div class="pb-1">
        {{ index + 1 }} : {{ piece }}
      </div>
    }
  </div>
</div>
}